export const data = {
  logbookName: "Draak Engine Log",
  logbookVersion: "1.0.0",
  primaryVerifiers: [],
  secondaryVerifiers: [],
  regulatory: 0,
  author: "",
  features: {
    panel: {
      align: "left",
    },
  },
  content: [
    {
      group: "ENG1",
      layout: "vertical",
      panel: "S1",
      style: "none",
      content: [
        {
          group: "ENG2",
          layout: "horizontal",
          panel: "S2",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Overview",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "none",
            color: "#303030",
            outline: "1px solid #b6c8d8",
            bold: true,
            entrySelector: "datePicker",
            description: "Header • Voyage • Remarks • Signatures",
          },
          content: [
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              padding: "6px",
              content: [
                {
                  group: "ENG3",
                  layout: "horizontal",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      label: {
                        text: "Vessel",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "name",
                      },
                    },
                    {
                      label: {
                        text: "Date",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "date",
                      },
                    },
                    {
                      label: {
                        text: "Duty Engineer",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "name",
                      },
                    },
                  ],
                },
                {
                  group: "ENG3",
                  layout: "horizontal",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      label: {
                        text: "Voyage From/At",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "text",
                      },
                    },
                    {
                      label: {
                        text: "Voyage To",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "text",
                      },
                    },
                    {
                      label: {
                        text: "ER Temp",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                  ],
                },
                {
                  group: "ENG3",
                  layout: "horizontal",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      label: {
                        text: "ER Humidity",
                      },
                      width: "33.3%",
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                  ],
                },
                {
                  group: "ENG3",
                  layout: "horizontal",
                  style: "none",
                  padding: "0px 6px",
                  inherited: {
                    text: {
                      padding: "0px 6px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      label: {
                        text: "Notes / Remarks",
                      },
                      outline: "none",
                      item: "1",
                      component: "textArea",
                    },
                    {
                      group: "ENG3",
                      layout: "vertical",
                      style: "none",
                      height: "100%",
                      inherited: {
                        text: {
                          padding: "0px 12px",
                        },
                        unit: {
                          width: "54px",
                          style: "inset-solid",
                        },
                        label: {
                          align: "flex-end",
                          textAlign: "left",
                          orientation: "top",
                          style: "none",
                          color: "#303030",
                        },
                      },
                      content: [
                        {
                          label: {
                            text: "Duty Engineer Sign",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "text",
                          },
                        },
                        {
                          label: {
                            text: "Chief Engineer Sign",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "text",
                          },
                        },
                        {
                          label: {
                            text: "Signed Time",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "text",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          group: "ENG3",
          layout: "horizontal",
          panel: "S3",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Main Engines - Parameters",
            panelText: "Main Engines",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            outline: "1px solid #b6c8d8",
            style: "none",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "Port (PS) and Starboard (SB)",
          },
          content: [
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  group: "ENG3",
                  layout: "vertical",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      item: "1",
                      component: "label",
                      text: "Port (PS)",
                      align: "flex-end",
                      padding: "12px 12px",
                      textAlign: "left",
                      orientation: "top",
                      color: "#303030",
                      bold: true,
                    },
                    {
                      label: {
                        text: "Engine Speed",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "rpm",
                      },
                    },
                    {
                      label: {
                        text: "L.O. Oil Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "L.O. Oil Temp",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Control Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "J/W Cooling Temp (Inlet)",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "J/W Cooling Temp (Outlet)",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Charge Air Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "Charge Air Temp",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Consumption",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "kg/h",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "Racor Filter DP",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "Exhaust Temp A",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Exhaust Temp B",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                  ],
                },
                {
                  group: "ENG3",
                  layout: "vertical",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      item: "1",
                      component: "label",
                      text: "Starboard (SB)",
                      align: "flex-end",
                      padding: "12px 12px",
                      textAlign: "left",
                      orientation: "top",
                      color: "#303030",
                      bold: true,
                    },
                    {
                      label: {
                        text: "Engine Speed",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "rpm",
                      },
                    },
                    {
                      label: {
                        text: "L.O. Oil Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "L.O. Oil Temp",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Control Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "J/W Cooling Temp (Inlet)",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "J/W Cooling Temp (Outlet)",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Charge Air Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "Charge Air Temp",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Consumption",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "kg/h",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Pressure",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "Racor Filter DP",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "bar",
                      },
                    },
                    {
                      label: {
                        text: "Exhaust Temp A",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                    {
                      label: {
                        text: "Exhaust Temp B",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "ºC",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          group: "ENG4",
          layout: "horizontal",
          panel: "S4",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Gearbox & Lubrication",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "clear",
            color: "#303030",
            outline: "1px solid #b6c8d8",
            bold: true,
            entrySelector: "datePicker",
            description: "As per sheet blocks",
          },
          content: [
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  item: "1",
                  component: "label",
                  text: "Main Gear Box",
                  align: "flex-end",
                  padding: "12px 12px",
                  textAlign: "left",
                  orientation: "top",
                  color: "#303030",
                  bold: true,
                },
                {
                  label: {
                    text: "PS – Shaft Speed",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "rpm",
                  },
                },
                {
                  label: {
                    text: "PS – Control Oil Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "rpm",
                  },
                },
                {
                  label: {
                    text: "PS – L.O. Oil Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "PS – L.O. Oil Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "SB – Shaft Speed",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "SB – Control Oil Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "SB – L.O. Oil Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "SB – L.O. Oil Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
              ],
            },
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  item: "1",
                  component: "label",
                  text: "Lubrication",
                  align: "flex-end",
                  padding: "12px 12px",
                  textAlign: "left",
                  orientation: "top",
                  color: "#303030",
                  bold: true,
                },
                {
                  label: {
                    text: "Sump Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Return L.O. Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Aft Bearing Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Stern Tube No.1 Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Steering Gear Hyd. Oil Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Stern Tube No.2 Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Shaft Horn No.1 Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Shaft Horn No.2 Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
              ],
            },
          ],
        },
        {
          group: "ENG5",
          layout: "vertical",
          panel: "S5",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Cooling, Fuel Txfr, Purifiers, Boilers",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            outline: "1px solid #b6c8d8",
            style: "clear",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "From sheet blocks",
          },
          content: [
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  group: "ENG3",
                  layout: "horizontal",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      group: "ENG3",
                      layout: "vertical",
                      style: "none",
                      inherited: {
                        text: {
                          padding: "0px 12px",
                        },
                        unit: {
                          width: "54px",
                          style: "inset-solid",
                        },
                        label: {
                          align: "flex-end",
                          textAlign: "left",
                          orientation: "top",
                          style: "none",
                          color: "#303030",
                        },
                      },
                      content: [
                        {
                          item: "1",
                          component: "label",
                          text: "Sea/Gen Cooling",
                          align: "flex-end",
                          padding: "12px 12px",
                          textAlign: "left",
                          orientation: "top",
                          color: "#303030",
                          bold: true,
                        },
                        {
                          label: {
                            text: "Inlet Temp",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "Outlet Temp",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "Inlet Pressure",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "Outlet Pressure",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "Sea Water Temp",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                      ],
                    },
                    {
                      group: "ENG3",
                      layout: "vertical",
                      style: "none",
                      inherited: {
                        text: {
                          padding: "0px 12px",
                        },
                        unit: {
                          width: "54px",
                          style: "inset-solid",
                        },
                        label: {
                          align: "flex-end",
                          textAlign: "left",
                          orientation: "top",
                          style: "none",
                          color: "#303030",
                        },
                      },
                      content: [
                        {
                          item: "1",
                          component: "label",
                          text: "Fuel Transfer / HFO Filters",
                          align: "flex-end",
                          padding: "12px 12px",
                          textAlign: "left",
                          orientation: "top",
                          color: "#303030",
                          bold: true,
                        },
                        {
                          label: {
                            text: "Discharge Pressure",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "General (Status/Flow)",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "HFO Filter DP",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "HFO No.1",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "HFO No.2",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                      ],
                    },
                    {
                      group: "ENG3",
                      layout: "vertical",
                      style: "none",
                      inherited: {
                        text: {
                          padding: "0px 12px",
                        },
                        unit: {
                          width: "54px",
                          style: "inset-solid",
                        },
                        label: {
                          align: "flex-end",
                          textAlign: "left",
                          orientation: "top",
                          style: "none",
                          color: "#303030",
                        },
                      },
                      content: [
                        {
                          item: "1",
                          component: "label",
                          text: "Purifiers",
                          align: "flex-end",
                          padding: "12px 12px",
                          textAlign: "left",
                          orientation: "top",
                          color: "#303030",
                          bold: true,
                        },
                        {
                          label: {
                            text: "L.O. Purifier 1 – Status",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "L.O. Purifier 2 – Status",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "F.O. Purifier 1 – Diff. Press",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                        {
                          label: {
                            text: "F.O. Purifier 2 – Diff. Press",
                          },
                          outline: "none",
                          item: "1",
                          component: "text",
                          unit: {
                            text: "ºC",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              width: "33.3%",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  item: "1",
                  component: "label",
                  text: "Boilers",
                  align: "flex-end",
                  padding: "12px 12px",
                  textAlign: "left",
                  orientation: "top",
                  color: "#303030",
                  bold: true,
                },
                {
                  label: {
                    text: "Steam Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Fuel Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Exhaust Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "HFO Filter DP",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Control (Status)",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Level",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Water",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
              ],
            },
          ],
        },
        {
          group: "ENG6",
          layout: "vertical",
          panel: "S6",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Machinery Hours",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "clear",
            outline: "1px solid #b6c8d8",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "Compressors / Pumps / Auxiliaries",
          },
          content: [
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Compressor No.1",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
                {
                  label: {
                    text: "Compressor No.2",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
                {
                  label: {
                    text: "Gen Pump No.1",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
                {
                  label: {
                    text: "Gen Pump No.2",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "FW Pump",
                  },
                  outline: "none",
                  width: "25%",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
                {
                  label: {
                    text: "Bilge Pump",
                  },
                  outline: "none",
                  width: "25%",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
              ],
            },
          ],
        },
        {
          group: "ENG7",
          layout: "vertical",
          panel: "S7",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Refrigeration / HVAC",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "clear",
            outline: "1px solid #b6c8d8",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "HP/LP • Evap/Cond • Stores",
          },
          content: [
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "HP Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "LP Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "Pressure Hot Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Cold Store Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Freezer Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Galley Chiller Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Galley Freezer (SB)",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
                {
                  label: {
                    text: "Galley Freezer (PS)",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
              ],
            },
          ],
        },
        {
          group: "ENG8",
          layout: "horizontal",
          panel: "S8",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Fresh Water / Watermaker",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "clear",
            outline: "1px solid #b6c8d8",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "Filters • Pressures • Product",
          },
          content: [
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  item: "1",
                  component: "label",
                  text: "Fresh Water",
                  align: "flex-end",
                  padding: "12px 12px",
                  textAlign: "left",
                  orientation: "top",
                  color: "#303030",
                  bold: true,
                },
                {
                  label: {
                    text: "Sea/FW Inlet Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "Sea/FW Outlet Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "Hydrophore Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "Calorifier Temp",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ºC",
                  },
                },
              ],
            },
            {
              group: "ENG3",
              layout: "vertical",
              style: "none",
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  item: "1",
                  component: "label",
                  text: "Watermaker",
                  align: "flex-end",
                  padding: "12px 12px",
                  textAlign: "left",
                  orientation: "top",
                  color: "#303030",
                  bold: true,
                },
                {
                  label: {
                    text: "Prefilter ΔP",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "Product Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
                {
                  label: {
                    text: "Product Flow",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "m³/h",
                  },
                },
                {
                  label: {
                    text: "Conductivity",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "µS/cm",
                  },
                },
                {
                  label: {
                    text: "Salinity",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "ppm",
                  },
                },
                {
                  label: {
                    text: "UV Steriliser Hours",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
                {
                  label: {
                    text: "Primary/Secondary UV Hours",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "hrs",
                  },
                },
                {
                  label: {
                    text: "RO Pressure",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                  unit: {
                    text: "bar",
                  },
                },
              ],
            },
          ],
        },
        {
          group: "ENG9",
          layout: "vertical",
          panel: "S9",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Tanks",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "clear",
            outline: "1px solid #b6c8d8",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "Totals/Service Tanks • Detailed Tank Levels",
          },
          content: [
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              label: {
                text: "Totals & Service Tanks (Ullage / Volume)",
                align: "flex-end",
                padding: "12px 12px",
                textAlign: "left",
                orientation: "top",
                color: "#303030",
                bold: true,
              },
              inherited: {
                text: {
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Fuel Total (All Tanks)",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Fuel Total (HFO)",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Fuel Total (MGO)",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "HFO Day Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "MGO Day Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "DG Settling Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "DG Service Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Sludge Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Bilge Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "L.O. Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Fresh Water Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "FW Maker Tank",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              label: {
                text: "Detailed Tank Levels (Litres)",
                align: "flex-end",
                padding: "12px 12px",
                textAlign: "left",
                orientation: "top",
                color: "#303030",
                bold: true,
              },
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  group: "ENG3",
                  layout: "vertical",
                  style: "none",
                  inherited: {
                    text: {
                      padding: "0px 12px",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      label: {
                        text: "Fuel Oil 7",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Oil 6",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Oil 5",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Oil 4",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Oil 3",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Oil 2",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fuel Oil 1",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Em. Generator Fuel",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Total Fuel",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Shaft Oil PS HDR",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Shaft Oil SB HDR",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Dirty LO",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Clean LO PS",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Clean LO SB",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                  ],
                },
                {
                  group: "ENG3",
                  layout: "vertical",
                  style: "none",
                  inherited: {
                    text: {
                      unitWidth: "54px",
                      unitStyle: "inset-solid",
                      padding: "0px 12px",
                    },
                    label: {
                      align: "flex-end",
                      textAlign: "left",
                      orientation: "top",
                      style: "none",
                      color: "#303030",
                    },
                  },
                  content: [
                    {
                      label: {
                        text: "Deckwash",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fresh Water 1",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Fresh Water 2",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Pool Water",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Grey Water 5",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Grey Water 4",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Grey Water 3",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Grey Water 2",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Grey Water 1",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Sewage Holding",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Sewage Mixing",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Bilge Beach Club",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Bilge Tender Garage",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                    {
                      label: {
                        text: "Main Bilge",
                      },
                      outline: "none",
                      item: "1",
                      component: "text",
                      unit: {
                        text: "Lts",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          group: "ENG10",
          layout: "vertical",
          panel: "S10",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Fuel Consumption",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            style: "clear",
            outline: "1px solid #b6c8d8",
            color: "#303030",
            bold: true,
            entrySelector: "datePicker",
            description: "Per sheet block",
          },
          content: [
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Port Main Engine",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Starboard Main Engine",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "DG Port",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "DG Stbd",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "DG Middle",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Incinerator",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Boiler",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Other/Notes",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
          ],
        },
        {
          group: "ENG11",
          layout: "vertical",
          panel: "S11",
          rounded: "12px",
          marginBottom: "24px",
          style: "clear",
          label: {
            text: "Running Hours (Aux)",
            textAlign: "left",
            padding: "6px 12px",
            orientation: "top",
            color: "#303030",
            outline: "1px solid #b6c8d8",
            bold: true,
            style: "clear",
            entrySelector: "datePicker",
            description: "List as per sheet",
          },
          content: [
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Line Transfer",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Suction Transfer",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "MSD Tank 1",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "MSD Tank 2",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "AHU Port",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "AHU Stbd",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Air Compressor",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
                {
                  label: {
                    text: "Fire Pump",
                  },
                  outline: "none",
                  item: "1",
                  component: "text",
                },
              ],
            },
            {
              group: "ENG3",
              layout: "horizontal",
              style: "none",
              inherited: {
                text: {
                  unitWidth: "54px",
                  unitStyle: "inset-solid",
                  padding: "0px 12px",
                },
                label: {
                  align: "flex-end",
                  textAlign: "left",
                  orientation: "top",
                  style: "none",
                  color: "#303030",
                },
              },
              content: [
                {
                  label: {
                    text: "Fire Pump",
                  },
                  outline: "none",
                  item: "1",
                  width: "25%",
                  component: "text",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
